import type { GroupLifeCalculateProposalPayload } from '@/services/group-life';
import { groupLifeProposalsService } from '@/services/proposals/group-life';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useCalculateGroupLifeProposal(policyId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['group-life-proposal', policyId, 'calculate'],
    mutationFn: async (payload?: GroupLifeCalculateProposalPayload) => {
      const result = await groupLifeProposalsService.calculateProposal(
        policyId,
        payload
      );
      if (!result.success) {
        throw new Error(result.error ?? 'Erro ao calcular a proposta');
      }
      return result;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['group-life-proposal', policyId],
      });
      await queryClient.invalidateQueries({
        queryKey: ['group-life', 'quote-details', policyId],
      });
      await queryClient.refetchQueries({
        queryKey: ['group-life-proposal', policyId],
      });
      await queryClient.refetchQueries({
        queryKey: ['group-life', 'quote-details', policyId],
      });
    },
  });
}
